var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductAvatar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 143,
    viewBox: "0 0 195 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 142,
    rx: 6.85714,
    fill: "#FACE8A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_482_3701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.267 102.861L70.589 103.254C67.4329 103.268 64.8593 100.723 64.8171 97.5879L64.3933 45.2744C64.3757 42.1177 66.9166 39.5466 70.0515 39.5079L124.73 39.1156C127.886 39.1015 130.459 41.6458 130.502 44.7812L130.925 97.0948C130.943 100.251 128.402 102.823 125.267 102.861Z",
    fill: "url(#paint0_linear_482_3701)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.189 95.0499L74.1221 95.4137C72.7625 95.4258 71.6681 94.3525 71.6545 92.9926L71.2898 49.7579C71.2762 48.3981 72.3481 47.3047 73.7078 47.2926L121.774 46.9288C123.134 46.9167 124.228 47.9901 124.242 49.35L124.607 92.5846C124.62 93.9445 123.548 95.0378 122.189 95.0499Z",
    fill: "#FDEFD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0839 64.5395C91.4703 63.3472 91.6265 61.2555 90.4328 59.8676C89.2391 58.4796 87.1475 58.3211 85.7612 59.5134C84.3748 60.7058 84.2187 62.7975 85.4124 64.1854C86.6061 65.5733 88.6976 65.7319 90.0839 64.5395Z",
    fill: "#FACE8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8818 78.8202L81.5368 78.9436L85.8319 74.0143L87.9794 71.5496L90.1269 69.0849L92.3157 71.5188L94.5044 73.9526L98.8818 78.8202Z",
    fill: "#AD91F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0685 70.1273L90.6111 69.8649L90.3526 70.1035L89.7468 69.9226L89.2095 70.1405L89.6698 69.6122L89.9 69.348L90.1302 69.0839L90.3648 69.3447L90.5993 69.6056L91.0685 70.1273Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.487 78.7189L88.2101 78.8987L94.4693 71.7152L97.5989 68.1234L100.728 64.5317L103.918 68.0785L107.108 71.6253L113.487 78.7189Z",
    fill: "#C8B5F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.101 66.0507L101.435 65.6684L101.058 66.0161L100.175 65.7524L99.3919 66.07L100.063 65.3001L100.398 64.9151L100.734 64.5302L101.075 64.9103L101.417 65.2904L102.101 66.0507Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_482_3701",
    x: 46.6079,
    y: 30.2231,
    width: 102.103,
    height: 99.7086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.89261
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_482_3701"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_482_3701",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_482_3701",
    x1: 68.0601,
    y1: 36.8127,
    x2: 126.517,
    y2: 104.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAvatar1);
export default __webpack_public_path__ + "static/media/productAvatar1.585157be47f38094f5b37eebfd62d2e0.svg";
export { ForwardRef as ReactComponent };